export function storeToken(token)  {
    sessionStorage.setItem("token", token);
}

export  function getAuthToken() {
    return sessionStorage.getItem("token");
}

export  function removeToken() {
    sessionStorage.removeItem("token");
}

export function getXSRFToken(){
    return sessionStorage.getItem("X-XSRF-TOKEN");
}
